export default __webpack_public_path__ + "media/fonts/foundation-icons/svgs/fi-foundation-bb144a1768bf7f395de19790c4efaafe.svg";